/**
 * ImageLightbox — a baked-in full-screen image viewer for extracted design figures /
 * spec images. Click a thumbnail to open; arrow keys / on-screen chevrons navigate the
 * set; click the image to toggle fit ↔ actual size; Esc or backdrop closes.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight, Download } from 'lucide-react';

const ImageLightbox = ({ images = [], index = 0, onIndex, onClose }) => {
  const [zoom, setZoom] = useState(false);
  const n = images.length;
  const im = images[index];
  const go = useCallback((d) => { if (n) { onIndex((index + d + n) % n); setZoom(false); } },
    [index, n, onIndex]);

  useEffect(() => {
    const h = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [go, onClose]);

  if (!im) return null;
  const src = im.data_url || im.url;
  const cap = [im.source, im.page ? `p${im.page}` : null,
    (im.width && im.height) ? `${im.width}×${im.height}` : null,
    n > 1 ? `${index + 1}/${n}` : null].filter(Boolean).join(' · ');

  return (
    <div className="forge-lightbox" onClick={onClose}>
      <div className="forge-lb-bar" onClick={(e) => e.stopPropagation()}>
        <span className="forge-lb-cap">{cap}</span>
        <span style={{ display: 'flex', gap: 8 }}>
          <a className="forge-lb-btn" href={src} download target="_blank" rel="noreferrer"><Download size={16} /></a>
          <button className="forge-lb-btn" onClick={onClose}><X size={18} /></button>
        </span>
      </div>
      {n > 1 && <button className="forge-lb-nav left" onClick={(e) => { e.stopPropagation(); go(-1); }}><ChevronLeft size={30} /></button>}
      <img className={`forge-lb-img ${zoom ? 'zoom' : ''}`} src={src} alt={im.source || 'image'}
        onClick={(e) => { e.stopPropagation(); setZoom((z) => !z); }} />
      {n > 1 && <button className="forge-lb-nav right" onClick={(e) => { e.stopPropagation(); go(1); }}><ChevronRight size={30} /></button>}
    </div>
  );
};

export default ImageLightbox;
